import { useContext, useEffect, useMemo, useState } from "react";
import { PageHeader } from "../../../shared/components/MainLayout/components"
import { AuthContext, InfoContext } from "../../../shared/contexts";
import { Tab, Tabs } from "@hdi-seguros/web-components.tabs";
import { ProducerInfoTab } from "./components/ProducerInfoTab";
import { ColSize, RowSize } from "../../../shared/components";
import { Typography } from "antd";
import { COLORS } from "../../../config/themes/colors";
import { ChangePasswordTab } from "./components/ChangePasswordTab";


export const UserPage = () => {
    const { setTitle } = useContext(InfoContext);
    const authContext = useContext(AuthContext);
    const [ activeTab, setActiveTab ] = useState('1');
    const [ username, setUsername ] = useState('');

    const handlePressTab = (activeTab: string) => setActiveTab(activeTab);


    useEffect(() => {
        setTitle('Datos productor');
        setUsername(authContext?.getUserInfo()?.intermediarioPrincipal?.nombreInter!)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const TABS: Array<Tab> = useMemo(() => [
        {
            label: 'Datos Productor',
            children: <ProducerInfoTab />,
            key: "1",
            closable: false,
        },
        {
            label: 'Cambio de contraseña',
            children: <ChangePasswordTab />,
            key: "2",
            closable: false,
        },
    ], []);

    return (
        <>
            <Typography.Title
                level={3}
                style={{
                  margin: 0,
                  marginBottom: 20,
            }}>
                {username}
            </Typography.Title>
            <RowSize>
                <ColSize size={100}>
                    <Tabs 
                        onChange={(key) => setActiveTab(key)}
                        handlePressTab={ handlePressTab }
                        activeKey={activeTab}
                        items={ TABS }
                    />
                </ColSize>
            </RowSize>
        </>
    )
}